import OutilsProject from "./OutilsProject";
import styles from "./index.module.scss";
import Image from "../global/Image";

const HeaderProject = ({ project, setImage }) => {
  return (
    <header className={styles.projectHeader}>
      <div className={styles.projectBanner}>
        <Image
          image={project.image}
          breakpoints={{ medium: "1000px", large: null }}
          alt={project.image.alt("project-banner", "Banière")}
        />
      </div>
      <div className={styles.metaInfo + " " + styles.gridLayout}>
        <div className={styles.projectImage + " previewImage"}>
          <Image
            image={project.image}
            alt={project.image.alt("main-thumbnail-project", "Vignette")}
            fit="contain"
            breakpoints={{
              thumbnail: "0px",
              small: "300px",
              medium: "800px",
              large: null,
            }}
            onClick={(e) =>
              setImage({
                x: e.clientX,
                y: e.clientY,
                img: project.image.load("url"),
              })
            }
          />
        </div>
        <div className={styles.titleContain}>
          <h1>
            {project?.seo?.title || project.name}
          </h1>
          <span className={styles.subtitle}>
            {project.date}
          </span>
        </div>
        <OutilsProject project={project} />
      </div>
    </header>
  );
};

export default HeaderProject;
